// extracted by mini-css-extract-plugin
export var border = "_h-7";
export var brand = "_h-s";
export var button = "_h-k";
export var center = "_h-9";
export var centered = "_h-5";
export var closeButton = "_h-b";
export var disabledWrapper = "_h-l";
export var error = "_h-o";
export var extraLarge = "_h-4";
export var extraSmall = "_h-1";
export var fill = "_h-h";
export var footer = "_h-g";
export var footerAction = "_h-i";
export var footerButtons = "_h-j";
export var header = "_h-6";
export var headerWithClose = "_h-c";
export var icon = "_h-n";
export var info = "_h-r";
export var inline = "_h-8";
export var large = "_h-3";
export var main = "_h-d";
export var modal = "_h-0";
export var neutral = "_h-t";
export var noPadding = "_h-f";
export var none = "_h-u";
export var scrollable = "_h-e";
export var small = "_h-2";
export var success = "_h-q";
export var tight = "_h-m";
export var titleIcon = "_h-a";
export var warn = "_h-p";